import { TemplatePage } from './types';

const animatedPage: TemplatePage = {
  header: {
    color: '#FFDC74',
    icon: 'images/video-templates/trending-animated.jpg',
    title: 'Trailer Video Templates Collection',
    title_meta: 'Editable and Free Trailer Video Templates',
    description_meta:
      'Create stunning trailer videos in a matter of minutes using' +
      ' Wave.video’s editable pro-looking trailer templates. Try now!',
    description:
      'Whether you need a trailer for a movie, game, product launch,' +
      ' or anything else, our trailer video templates have got you' +
      ' covered. Pick a trailer template and customize it to fit your' +
      ' brand and message within minutes!'
  },
  footer: {
    category: 'Trailers',
    description:
      'Whether you need a trailer for a movie, game, product launch, or anything' +
      ' else, our trailer video templates have got you covered. Pick a trailer' +
      ' template and customize it to fit your brand and message within minutes!'
  },
  content: [
    {
      type: 'templates',
      title: 'Trailer Video Templates',
      search: { category: "/Use Cases/Trailers" }
    },
    {
      type: 'stocks',
      title: 'trailer',
      search: { name: 'trailer' }
    },
    { type: 'calendar' }
  ]
};

export default animatedPage;
